import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import SellerError from '../../../components/Seller/Error'
import { setErrorBoundaryError } from '../../../actions'

const setNotFound = (message = '發生錯誤') => {
  return setErrorBoundaryError({ message })
}

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  const actions = {
    setNotFound
  }

  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

// Overrides default preFetcher in app.server.js
SellerError.preFetcher = ({ store, req, res }) => {
  return Promise.resolve()
}

SellerError.fetchData = async ({
  store,
  req,
  res,
  match
}) => {
  try {
    const tasks = []
    return Promise.all(tasks)
  } catch (e) {
    throw e
  }
}

const MappedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(SellerError)

export default MappedComponent
